const React = require('react');
const PropTypes = require('prop-types');
const CenteredLayout = require('components/CenteredLayout');
const { NavLink: Link } = require('react-router-dom');
const { default: Classes } = require('./styles.scss');

const internals = {};

module.exports = class VerifyEmail extends React.PureComponent {

    static propTypes = {
        resendEmail: PropTypes.func.isRequired,
        signupDetails: PropTypes.shape({
            email: PropTypes.string,
            schoolId: PropTypes.number
        })
    }

    constructor(props) {

        super(props);

        this.resendEmail = this._resendEmail.bind(this);
    }

    _resendEmail(ev) {

        ev.preventDefault(); // Don't actually follow the link, just use an <a/> for UX

        this.props.resendEmail(this.props.signupDetails);
    }

    render() {

        const { email } = this.props.signupDetails;

        return <CenteredLayout header='Create Account' mainClass={Classes.main}>
            <p className={Classes.emailHolder}>
                <span className={Classes.maybeBreak}>A verification email</span>
                <span className={Classes.maybeBreak}>has been sent to</span>
                <span className={Classes.maybeBreak}><span className={Classes.email}>{email}</span></span>
            </p>
            <p>
                Please follow the instructions in that message to confirm your email address.
            </p>
            <p>
                {'If you haven\'t received this email within a few minutes, please check your spam folder.'}
            </p>
            <div>
                <div className={Classes.linkWrapper}>
                    <a href='' onClick={this.resendEmail}>Resend Verification Email</a>
                </div>
                {/*<div className={Classes.linkWrapper}>
                    <Link to='/signup'>Change My Email Address</Link>
                </div>*/}
                <div className={Classes.linkWrapper}>
                    <Link to='/'>Go to Log In</Link>
                </div>
            </div>
        </CenteredLayout>;
    }
};
